import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ICustomer } from '../../../../../Customer/interfaces/ICustomer'
import { CustomerAvatar } from '../CustomerAvatar'

import {
  UserInputDropdownContentMainText,
  UserInputDropdownContentTextWrapper,
  UserInputDropdownContentAvatar,
  UserInputDropdownContentSubText,
} from './style'

interface IProps {
  customerList: ICustomer[]
  setSearchInput: (customerName: string) => void
  setVisible: (state: false) => void
  setValue: UseFormSetValue<any>
}

export const CustomerList: FunctionComponent<IProps> = ({
  customerList,
  setVisible,
  setValue,
  setSearchInput,
}) => {
  const { t } = useTranslation()
  const onCustomerSelect = (customer: ICustomer) =>
    setSearchInput(`${customer.customerName} ${customer.customerLastName}`)

  if (customerList.length === 0) {
    return (
      <UserInputDropdownContentMainText>
        <FontAwesomeIcon icon="plus-circle" />
        {t('Add customer')}
      </UserInputDropdownContentMainText>
    )
  }
  return (
    <>
      {customerList.map(customer => (
        <UserInputDropdownContentTextWrapper
          key={customer.id}
          onClick={() => {
            onCustomerSelect(customer)
            setValue('customerUuid', customer.customerUuid)
            setVisible(false)
          }}
        >
          <UserInputDropdownContentAvatar>
            <CustomerAvatar customer={customer} />
          </UserInputDropdownContentAvatar>
          <UserInputDropdownContentMainText>
            {`${customer.customerName} ${customer.customerLastName}`}
          </UserInputDropdownContentMainText>
          <UserInputDropdownContentSubText>
            {`${customer.address}`}
          </UserInputDropdownContentSubText>
        </UserInputDropdownContentTextWrapper>
      ))}
    </>
  )
}
